module.exports = __webpack_public_path__ + "static/media/zbrojnice_Paskov_(2).d6bc28c3.jpg";